"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _mockApolloClient = _interopRequireDefault(require("../_mockApolloClient.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SummaryTable = function SummaryTable(props) {
  var _renderValues = function _renderValues(value) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, value, "/", props.totalSessions);
  };
  var columns = [{
    name: 'name',
    label: 'Participant List',
    sort: true
  }, {
    name: 'attended',
    label: 'Sessions Attended',
    sort: true,
    className: 'text-center',
    render: function render(_ref) {
      var value = _ref.value;
      return _renderValues(value);
    }
  }, {
    name: 'participated',
    label: 'Participated',
    sort: true,
    className: 'text-center',
    render: function render(_ref2) {
      var value = _ref2.value;
      return _renderValues(value);
    }
  }, {
    name: 'behaviorProblems',
    label: 'Behavior Problems',
    sort: true,
    className: 'text-center',
    render: function render(_ref3) {
      var value = _ref3.value;
      return _renderValues(value);
    }
  }, {
    name: 'redirection',
    label: 'Needed Redirection',
    sort: true,
    className: 'text-center',
    render: function render(_ref4) {
      var value = _ref4.value;
      return _renderValues(value);
    }
  }, {
    name: 'skills',
    label: 'Demonstrated Skills',
    sort: true,
    className: 'text-center',
    render: function render(_ref5) {
      var value = _ref5.value;
      return _renderValues(value);
    }
  }];
  return /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    apolloClient: props.isPreview ? _mockApolloClient["default"] : undefined,
    query: props.query,
    columns: columns
  });
};
var _default = exports["default"] = SummaryTable;